import { isNullOrUndefined } from 'app/common/utils/utils.object';
import { filter, Observable, OperatorFunction } from 'rxjs';

export const filterNullOrUndefined =
	<T>(): OperatorFunction<T, T> =>
	(source: Observable<T>) =>
		source.pipe(filter((value: T) => !isNullOrUndefined(value)));
